<template>
  <div class="orderListWrap overWrap">
    <header>
      <span class="title">仅支持查询近一年订单</span>
      <div class="income-source">
        <div class="name">订单状态</div>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="orderState"
            :options="StateOptions.slice(0, 6)"
            @change="selectStateChange"
          />
        </van-dropdown-menu>
      </div>
    </header>
    <div class="table-wrap">
      <p-datatable
        :value="dataList"
        showGridlines
        stripedRows
        responsiveLayout="scroll"
        :scrollable="true"
        scrollDirection="both"
        class="p-datatable-sm"
      >
        <p-column
          v-for="(item, index) in tableColums"
          :key="index"
          :field="item.id"
          :header="item.label"
          :frozen="index === 0"
          :styles="{
            'flex-grow': '1',
            'flex-basis': getColsWidth(item),
            'white-space': 'pre-wrap',
          }"
          :bodyClass="item.id"
        >
          <template #body="slotProps">
            <a
              v-if="item.id === 'optioner'"
              class="operation"
              href="javascript:void(0);"
              @click="showDetail(slotProps.data)"
            >
              详情
            </a>
            <span
              v-else-if="item.id === 'state'"
              class="state"
              :class="'state' + slotProps.data[item.id]"
              @click="showCurrRejectReason(slotProps.data)"
            >
              {{ slotProps.data[item.id] | getStatusText }}
            </span>
            <span v-else>{{ slotProps.data[item.id] }}</span>
          </template>
        </p-column>
        <template #empty>
          <nodata></nodata>
        </template>
      </p-datatable>
    </div>
    <div class="pagnation-wrap">
      <van-pagination
        v-model="pagination.page"
        :total-items="pagination.total"
        :show-page-size="5"
        @change="allDataPageChange"
      >
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
      <div class="jump-wrap">跳至</div>
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="pagination.page"
          :options="detailOption"
          @change="allDataPageChange"
        >
        </van-dropdown-item>
      </van-dropdown-menu>
      页
    </div>
    <van-dialog
      v-model="showDetailDialog"
      title="订单详情"
      :show-cancel-button="false"
      :show-confirm-button="false"
      width="4.57333rem"
      closeOnClickOverlay
    >
      <div class="orderDetails">
        <div class="row">
          <div class="rowLabel">订单编号</div>
          <div class="rowValue">{{ orderDetail.id }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">订单状态</div>
          <div class="rowValue">{{ orderDetail.state | getStatusText }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">收件人</div>
          <div class="rowValue" v-if="orderDetail.goods_type === 1">
            {{ orderDetail.buyer_name }}
          </div>
          <div class="rowValue" v-else>
            {{ orderDetail.uin_name }}（{{ orderDetail.uin }}）
          </div>
        </div>
        <div class="row" v-if="orderDetail.goods_type === 1">
          <div class="rowLabel">收件人手机号</div>
          <div class="rowValue">{{ orderDetail.buyer_phone }}</div>
        </div>
        <div class="row">
          <div class="rowLabel">收货方式</div>
          <template v-if="orderDetail.goods_type === 1">
            <div class="rowValue" v-if="orderDetail.email_id">
              快递单号：{{ orderDetail.email_id }}
            </div>
            <div class="rowValue" v-else>快递单号待更新</div>
          </template>
          <div class="rowValue" v-else>虚拟商品，系统发放至游戏邮箱</div>
        </div>
        <div class="row" v-if="orderDetail.email_id">
          <div class="rowLabel">收货地址</div>
          <div class="rowValue">{{ orderDetail.buyer_address }}</div>
        </div>
      </div>
      <div class="productionCard">
        <img :src="orderDetail.image" />
        <table>
          <thead>
            <tr>
              <th>商品名称</th>
              <th>下单时间</th>
              <th>价格</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="orderDetailTable.length">
              <td>{{ orderDetailTable[0].name }}</td>
              <td>{{ orderDetailTable[0].time }}</td>
              <td>{{ orderDetailTable[0].price }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </van-dialog>
    <div
      class="mask4rejectDialog"
      v-show="isShowCurrRejectReason"
      @click="closeRejectDialog"
    />
    <!-- <van-popup
      v-model="isShowCurrRejectReason"
      position="bottom"
      :style="{ height: '40%' }"
      >{{ currRejectReason }}</van-popup
    > -->
  </div>
</template>
<script>
import mixins from '../../../mixins/exchangeShop/orderList.mixins';
import nodata from '../../../components/m/nodata.vue';
export default {
  mixins: [mixins],
  components: {
    'p-datatable': window.datatable,
    'p-column': window.column,
    nodata,
  },
  watch: {
    isShowCurrRejectReason(newval) {
      console.log('isShowCurrRejectReason---', newval);
      if (newval) {
        // this.$dialog({ message: this.currRejectReason });
        this.$dialog.confirm({
          title: '拒绝理由',
          message: this.currRejectReason,
          showConfirmButton: false,
          showCancelButton: false,
          closeOnClickOverlay: true,
          overlay: false,
          className: 'rejectDialog',
        });
        // .then(() => {
        //   console.log("dialog then");
        //   this.isShowCurrRejectReason = false;
        // });
      }
    },
  },
  methods: {
    getColsWidth(item) {
      let width = '90px';
      switch (item.id) {
        case 'id':
          width = '130px';
          break;
        case 'goods_name':
          width = '250px';
          break;
        case 'goods_price':
          width = '120px';
          break;
        case 'create_time':
          width = '200px';
          break;
        case 'state':
          width = '160px';
          break;
        case 'optioner':
          width = '120px';
          break;
      }
      return width;
    },
    closeRejectDialog() {
      this.$dialog.close();
      this.isShowCurrRejectReason = false;
    },
  },
};
</script>
<style
  src="../../../style/exchange-shop/m/common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    height: 37px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #595959;
    line-height: 37px;
  }
  .income-source {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .name {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 40px;
      margin-right: 12px;
    }
    ::v-deep .van-dropdown-menu {
      width: 160px;
      .van-dropdown-item__option--active,
      .van-dropdown-menu__title--active,
      .van-dropdown-item__option--active .van-dropdown-item__icon {
        color: #fd9b21;
      }
    }
  }
}
.operation {
  color: #3b9aff;
}
.orderDetails {
  padding: 32px;
  .row {
    display: flex;
    justify-content: space-between;
    font-size: 28px;
    color: rgba(89, 89, 89, 1);
    height: 40px;
    margin-bottom: 30px;
  }
}
.productionCard {
  width: 622px;
  min-height: 159px;
  background: #fffcf4;
  border-radius: 6px;
  border: 1px solid #ffcc40;
  margin: 0 auto 36px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 20px 14px 0;
  img {
    width: 100px;
    height: 100px;
    background: #fef4de;
    border-radius: 4px;
    margin-right: 14px;
    margin-bottom: 14px;
  }
  table {
    width: 100%;
    max-width: 480px;
    thead {
      border-bottom: 1px solid #ebebeb;
      tr {
        height: 52px;
      }
    }
    th,
    td {
      white-space: wrap;
      font-size: 20px;
      color: #595959;
      font-weight: 400;
      text-align: center;
      max-width: 200px;
    }
    td {
      font-size: 22px;
      font-weight: 500;
    }
    tbody {
      tr {
        height: 82px;
      }
    }
  }
}

td.goods_name {
  width: 250px;
  white-space: pre-wrap;
}
.orders-subtable {
  display: block;
  width: 100%;
  .rowDetail {
    width: 60%;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    span {
      margin: 4px 59px 4px 0;
      font-size: 24px;
      color: #000;
      label {
        color: #595959;
        padding-right: 16px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &.moreInfo .rowDetail {
    width: 60%;
  }
}
::v-deep .p-datatable-responsive-scroll > .p-datatable-wrapper > table {
  width: 240%;
}
::v-deep .van-popup.van-popup--bottom {
  padding: 20px;
  box-sizing: border-box;
  word-break: break-all;
  word-break: break-word;
}
</style>
<style lang="scss">
.orderListWrap {
  .state {
    color: #262626;
    white-space: nowrap;
    // &.state1 {
    //   color: #f56c6c;
    // }
    &.state1 {
      color: #3b9aff;
    }
    &.state4,
    &.state6 {
      color: #59d040;
    }
  }
}
.mask4rejectDialog {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
}
.rejectDialog .van-dialog__header {
  color: #646566;
}
</style>
